export default __webpack_public_path__ + "static/Graphik-Bold-Cy-Web-54cdb8d3c23ba8df50a51a9da6bad884.woff2";